import React from 'react';
import styled from 'styled-components';
import Link from 'next/link';
import { Mixins } from 'planoplan-ui-kit/core/mixins';
import { Colors } from 'planoplan-ui-kit/core/colors';
import { textSize, marginLevel, Points } from '@styles';

export const Breadcrumbs = ({ links = [], isOpenInEditorIframe = false }) => {
  const countOfLinks = links.length;

  return (
    <View isOpenInEditorIframe={isOpenInEditorIframe}>
      {links.map(({ href, name }, index) => (
        <Item key={index} countOfLinks={countOfLinks}>
          {href?.length > 0 ? (
            <Link href={href} passHref>
              <a>{name}</a>
            </Link>
          ) : (
            <div>{name}</div>
          )}
        </Item>
      ))}
    </View>
  );
};

const View = styled.ul`
  ${Mixins.resetList()};
  ${textSize('description')};
  ${marginLevel('bottom', 'azure')};
  display: flex;
  flex-wrap: ${(p) => p.isOpenInEditorIframe && 'wrap'};
  color: ${Colors.second_gray};
  overflow: hidden;
  white-space: ${(p) => (p.isOpenInEditorIframe ? 'pre-wrap' : 'nowrap')};
  width: inherit;
  overflow: auto;
  white-space: nowrap;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }

  li,
  a,
  li div {
    white-space: ${(p) => p.isOpenInEditorIframe && 'pre-wrap !important'};
  }
`;

const Item = styled.li`
  margin-right: 10px;
  display: flex;
  align-items: center;

  @media ${Points.tablet_landscape} {
    max-width: ${(p) => `calc(100% / ${p.countOfLinks})`};
  }

  &:before {
    content: '';
    display: block;
    min-width: 24px;
    width: 24px;
    height: 24px;
    background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='13' viewBox='0 0 8 13' fill='none'%3e%3cpath d='M0.999999 12.5L6.5 7L0.75 1.25' stroke='%23868686'/%3e%3c/svg%3e");
    background-position: center center;
    background-repeat: no-repeat;
    margin-right: 10px;
  }

  &:first-child:before {
    display: none;
  }

  &:last-child {
    color: ${Colors.main_black};
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    min-width: max-content;

    @media ${Points.tablet_landscape} {
      text-overflow: ellipsis;
      min-width: 0;
    }
  }

  a,
  div {
    overflow: hidden;
    white-space: nowrap;
    display: block;

    @media ${Points.tablet_landscape} {
      text-overflow: ellipsis;
      min-width: 0;
    }
  }

  a {
    ${Mixins.resetLink()};
    ${Mixins.transition('color')};

    @media (hover: hover) and (pointer: fine) {
      &:hover {
        color: ${Colors.second_blue};
      }
    }

    &:active {
      color: ${Colors.main_blue};
    }
  }
`;
